import React from 'react'
import { InputProps } from 'react-admin'

export const DiscountField = ({ record }: InputProps) => {
  return <span>{record.discount * 100} %</span>
}
